import JSDB from 'fromKotlin/nk';

export interface OtherAppConfig {
    url: string;
    title: string;
}

/** Per-company external app from `User.getJsonDesc('other_app')`.
 *  default_notes entry: `{ name: "מערכת HACCP", type: "https://...", param: "other_app" }` */
export function getOtherAppConfig(): OtherAppConfig | null {
    try {
        const user = JSDB().getUser()?.first;
        if (!user) return null;
        const raw = user.getJsonDesc?.('other_app');
        if (!raw) return null;
        const urlCandidate = raw.url || raw.type;
        const url =
            typeof urlCandidate === 'string' && /^https?:\/\//i.test(urlCandidate.trim())
                ? urlCandidate.trim()
                : null;
        if (!url) return null;
        return {
            url,
            title: raw.title || raw.name || 'אפליקציה חיצונית',
        };
    } catch {
        return null;
    }
}

export function otherAppEnabled(): boolean {
    return getOtherAppConfig() !== null;
}
